export const SET_SELECTED_STATUS_ACTION = 'selectedStatus';
export const SET_SEARCH_TEXT_ACTION = 'searchText';
export const SET_EMPRESA_ACTION = 'empresa';
export const SET_CENTRO_CUSTO_ACTION = 'centroCusto';
export const SET_PRODUTO_ACTION = 'produto';
export const SET_PROJETO_ACTION = 'projeto';
export const SET_RESPONSAVEL_ACTION = 'responsavel';
export const SET_DATA_FINAL_ACTION = 'dataFinal';
export const SET_DATA_INICIAL_ACTION = 'dataInicial';
export const SET_URGENCIA_ACTION = 'urgencia';
export const SET_COMPRADOR_RESPONSAVEL_ACTION = 'compradorResponsavel';
export const SET_GRUPO_ACTION = 'grupo';
export const SET_SITUACAO_ACTION = 'situacao';
